import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Action
export const fetchSupervisorsList = createAsyncThunk("fetchSupervisorsList", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		keyword: filters?.keyword ?? "",
		page: page,
		limit: limit,
	});

	try {
		const response = await axiosHttp.get(`supervisors?${params}`);
		return response.data.data;
	} catch (error) {
		console.error("API Error:", error);
		throw error;
	}
});

const SupervisorsListSlice = createSlice({
	name: "SupervisorsListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSupervisorsList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSupervisorsList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload?.page ?? 1;
			state.total = action.payload?.total ?? 0;
		});

		builder.addCase(fetchSupervisorsList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SupervisorsListSlice.reducer;
